<template>
  <v-card>
    <v-card-title class="primary white--text">
      <span class="headline">{{ title }}</span>
      <v-spacer/>
      <BaseDialogActions hideRefresh hideFullscreen @close="onBaseDialogClose"/>
    </v-card-title>
    <v-card-text class="mt-6">
      <FormWrapper
        :buttonText="buttonText"
        :disabled="isDisabled"
        @submit="onConfirm">
        <template #left-action>
          <v-btn text @click="onCancel">{{ $t('cancel') }}</v-btn>
        </template>
        <v-row no-gutters>
          <v-col cols="12" class="mb-2">
            <DatePicker
              :dateLabel="$t('effectiveDate')"
              :startDate="selectedDate"
              @date-picked="selectedDate = $event"/>
          </v-col>
          <v-col cols="12">
            <TimePicker
              :label="$t('time')"
              :startTime="selectedTime"
              :expandable="false"
              @time-picked="onTimePicked"
              @enter-pressed="onEnterPressed"/>
          </v-col>
        </v-row>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DateTimeSelectionDialog',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    DatePicker: () => import('@/components/helper/DatePicker.vue'),
    TimePicker: () => import('@/components/helper/TimePicker.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue')
  },

  props: {
    title: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    startDate: {
      type: String,
      default: null
    },
    startTime: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      selectedDate: this.startDate,
      selectedTime: this.startTime,
      timeSelected: !!this.startTime
    }
  },

  computed: {
    isDisabled () {
      return !this.selectedDate || !this.timeSelected
    }
  },

  methods: {
    onTimePicked (time) {
      this.selectedTime = time
      this.timeSelected = true
    },

    onEnterPressed () {
      if (!this.isDisabled) this.onConfirm()
    },

    onConfirm () {
      this.$emit('confirm', { date: this.selectedDate, time: this.selectedTime })
    },

    onCancel () {
      this.$emit('cancel')
    },

    onBaseDialogClose () {
      this.$emit('cancel')
    }
  }
}
</script>
